import { Component, Vue, toNative } from 'vue-facing-decorator';
import template from './app.html?raw';
// components
import AppLayout from '@/layouts/app/app';
import { getThemeColor } from './appTheme';

@Component({
  template,
  components: {
    AppLayout,
  },
})
class App extends Vue {
  created() {
    this.updateUIFrameWork();
  }

  public updateUIFrameWork() {
    const { primary, secondary } = this.$vuetify.theme.themes.light.variables;

    const lightTheme = this.$vuetify.theme.themes.light.variables;
    lightTheme.primary = getThemeColor('dark') || primary;
    lightTheme.secondary = getThemeColor('secondary') || secondary;
  }
}

export default toNative(App);